module.exports = __webpack_public_path__ + "6a8c2108ed5acd958e6c551823149a98.MP3";